import { defineStore } from 'pinia'

export const useAllisStore = defineStore({
  id: 'allis',
  state: () => {
    return {
      menuOverlayStatus: false,
      overlayVideoStatus: false,
      overlayVideoID: 'M-3-8fovRpk',
      isMouseOver: false,
      mouseFollowerText: 'View',
      mouseFollowerDisabled: false,
      isMouseDragging: false,
      userIdle: false
    }
  },
  actions: {
    openModalVideo(idx){
      this.overlayVideoStatus = true
      this.overlayVideoID = idx
    },
  }
})